<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="infoDetails" :loading="this.loading" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Transactions</h5>
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="expSetNow()"
                    fdprocessedid="1yahzs"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-3 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        placeholder="Search"
                        v-model="search_key"
                        @input="fetchList(1)"
                      />

                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div class="col-xxl-1 col-sm-6">
                    <Filteroption
                      :filterOptions="filterByOptions"
                      :initialSelected="'customer_name'"
                      @apply="handleApplyFilters"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div>
                <br />
                <br />
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :ldata="ldata"
                      :headers="headers"
                      :tableData="formattedSettelments"
                      :editBtn="false"
                      @edit="editSettlement"
                      @delete="openDeleteDialog"
                      @refunded-click="refundTransactionsPopup"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="transactions.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="transactions.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="transactions.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
              <DeleteDialog
                title="Delete Trasactions ?"
                ref="deleteDialog"
                @confirm="deleteTransactions"
              />
              <ToastNotification ref="toast" />
              <loaderLoading v-if="overallLoading" />

              <div
                class="modal fade show"
                tabindex="-1"
                style="display: block; background-color: rgba(0, 0, 0, 0.5)"
                v-if="showRefundModal"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content rounded-3">
                    <div class="modal-header bg-warning p-2">
                      <h5 class="modal-title">Refund Options</h5>
                      <button
                        type="button"
                        class="btn-close"
                        @click="showRefundModal = false"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <p>
                        Choose how you want to refund for
                        <strong>{{
                          selectedUser?.customeName || selectedUser?.customerID
                        }}</strong
                        >:
                      </p>
                      <div class="d-flex justify-content-around mt-3">
                        <button
                          style="width: 150px"
                          class="btn btn-warning"
                          @click="refundToWallet"
                        >
                          <div
                            v-if="refundLoading"
                            class="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          <span v-else> Refund to Wallet </span>
                        </button>
                        <button
                          style="width: 150px"
                          class="btn text-warning border border-warning"
                          @click="refundToAccount"
                        >
                          <div
                            v-if="accountLoading"
                            class="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          <span v-else> Refund to Account </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listMixin from "@/mixins/listMixin";
import { transactionInfoDetails } from "@/constants/infodetails";
import {
  getAllTransactions,
  deleteTransaction,
  updateTransaction,
} from "@/apis/transaction";
import { transactionHeaders } from "@/constants/headers";
import Filteroption from "@/components/filter/filteroption.vue";
import { transactionFilterByOptions } from "@/constants/filter";
import { refundTransactions } from "@/apis/payU";
import { getCustomerById } from "@/apis/customer";
import { createWallet } from "@/apis/wallet";
import { useAuthStore } from "@/store/auth";
import { mapState } from "pinia";

export default {
  name: "trasactionList",

  mixins: [listMixin],
  components: { Filteroption },

  data() {
    return {
      transactions: [],

      showRefundModal: false,
      selectedUser: null,

      infoDetails: transactionInfoDetails,
      headers: transactionHeaders,
      filterByOptions: transactionFilterByOptions,

      refundLoading: false,
      accountLoading: false,
    };
  },

  methods: {
    expSetNow() {
      const fields = [
        "customerID",
        "customerName",
        "mobile",
        "createdAt",
        "payUReference",
        "payUTransactionID",
        "amount",
        "status",
        "bookingStatus",
        "refunded",
      ];
      this.$exportCsv(this.formattedSettelments, "Transaction.csv", fields);
    },
    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getAllTransactions, {
        [this.selectedFilterValue]: this.search_key,
      });

      this.transactions = response.data;
      this.stopLoading();
    },

    async refundToWallet() {
      this.refundLoading = true;
      const walletId = await this.getUserById(this.selectedUser.customerID);

      const payload = {
        points: this.selectedUser.amount,
        depositType: "credit",
        referenceType: "refund",
        comment: `Refund for your booking. Sorry for the inconvenience`,
        referenceId: "xxxx",
        initiatorEmail: this.ldata.email,
      };

      const response = await createWallet(walletId, payload);
      if (response.success) {
        await this.updateRefundStatus();
        this.showRefundModal = false;
        this.$refs.toast.showToast(
          "Successfully Refunded to the Customer Wallet",
          "success"
        );
        await this.fetchList(1);
      } else {
        this.$refs.toast.showToast("Failed to Refund", "error");
      }

      this.refundLoading = false;
    },

    async refundToAccount() {
      this.accountLoading = true;
      const payload = {
        payuId: this.selectedUser.payUTransactionID,
        refundToken: "your-refund-token",
        amount: this.selectedUser.amount,
        refundDetails: {
          reason: "Refund for your booking. Sorry for the inconvenience.",
        },
      };

      const result = await refundTransactions(payload);
      if (result.status === "SUCCESS") {
        this.$refs.toast.showToast(
          "Successfully Refunded to the Customer Bank Account",
          "success"
        );
      } else {
        this.$refs.toast.showToast("Failed to Refund", "error");
      }

      this.accountLoading = false;
    },

    async updateRefundStatus() {
      const response = await updateTransaction(this.selectedUser.id, {
        refunded: "true",
      });

      if (response.success) {
        return response;
      }
    },

    async getUserById(userId) {
      const response = await getCustomerById(userId);

      if (response.success) {
        return response.data.wallet_details?.wallet_id;
      }
    },

    async deleteTransactions(transaction) {
      await this.delete(deleteTransaction, transaction.id);
    },

    refundTransactionsPopup(user) {
      if (user.refunded) return;
      this.selectedUser = user;
      this.showRefundModal = true;
    },
  },

  computed: {
    ...mapState(useAuthStore, ["ldata"]),

    formattedSettelments() {
      return this.transactions.map((transaction) => ({
        id: transaction.id,
        spec_id: transaction.transaction_id,
        customerID: transaction.customer_id,
        customerName: transaction.customer_name,
        mobile: transaction.customer_contact || "N/A",
        createdAt: transaction.created_at
          ? new Date(transaction.created_at).toLocaleString()
          : "N/A",
        payUReference: transaction.pay_u_reference || "N/A",
        payUTransactionID: transaction.pay_u_transaction_id || "N/A",
        amount: transaction.amount,
        status: transaction.amount_debited,
        bookingStatus: transaction.booking_status,
        refunded: transaction.refunded,
      }));
    },
  },
};
</script>
